<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $tc('tax', 2) }} {{ $tc('setting', 2) }}</div>
      <div>
        <!-- <router-link class="btn-blue" to="edit-charge-setting">{{ $t('edit') }}</router-link> -->
        <router-link
          class="btn-blue"
          to="tax-settings"
        >{{ $tc('tax', 2) }} {{ $tc('setting', 2) }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('cinema', 1) }}</div>
              <div
                v-if="CinemasChargeType && CinemasChargeType.length > 0"
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ CinemasChargeType[0].cine_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('chargesettingname') }}</div>
              <div
                v-if="CinemasChargeType && CinemasChargeType.length > 0"
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ CinemasChargeType[0].pas_charge_setting_name }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 mt-2">
        <table class="table border">
          <thead class="thead-light">
            <tr>
              <th class="text-center">{{ $tc('Tax', 2) }} {{ $tc('type', 2) }}</th>
              <th class="text-center">{{ $t('value') }}</th>
              <th class="text-center">{{ $t('isPercentage') }}</th>
              <th class="text-center">{{ $t('isdeduction') }}</th>
              <th class="text-center">{{ 'Shareable With Distributor' }}</th>
              <th class="text-center">{{ $t('isTaxable') }}</th>
              <th class="text-center">{{ $tc('status', 1) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="text-center"
              v-for="(chargesetting, chargesettingIndex) in CinemasChargeType"
              :key="chargesettingIndex"
            >
              <td class="text-center">{{ chargesetting.ct_name }}</td>
              <td class="text-center">{{ chargesetting.pas_charge_value }}</td>
              <td class="text-center">
                <div
                  v-if="chargesetting.pas_is_percentage == 'Y'"
                  class="col-md-9 col-lg-10 col-xl-10"
                >Yes</div>
                <div v-else class="col-md-9 col-lg-10 col-xl-10">No</div>
              </td>
              <td class="text-center">
                <div
                  v-if="chargesetting.pas_is_deduction == 'Y'"
                  class="col-md-9 col-lg-10 col-xl-10"
                >Yes</div>
                <div v-else class="col-md-9 col-lg-10 col-xl-10">No</div>
              </td>
              <td class="text-center">
                <div
                  v-if="chargesetting.pas_is_shareable_with_distributor == 'Y'"
                  class="col-md-9 col-lg-10 col-xl-10"
                >Yes</div>
                <div v-else class="col-md-9 col-lg-10 col-xl-10">No</div>
              </td>
              <td class="text-center">
                <div
                  v-if="chargesetting.pas_is_taxable == 'Y'"
                  class="col-md-9 col-lg-10 col-xl-10"
                >Yes</div>
                <div v-else class="col-md-9 col-lg-10 col-xl-10">No</div>
              </td>
              <td class="text-center">
                <div
                  v-if="chargesetting.ct_is_active == 'Y'"
                  class="col-md-9 col-lg-10 col-xl-10"
                >Active</div>
                <div v-else class="col-md-9 col-lg-10 col-xl-10">Inactive</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12">
        <div class="row">
          <div v-if="roleid == 1" class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
                <span>{{ cinemaChargesSettings.pas_created_by }}</span>
              </div>
            </div>
          </div>

          <div v-if="roleid == 1" class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ cinemaChargesSettings.pas_created_at | dateparse }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>

          <div v-if="roleid == 1" class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
                <span>{{ cinemaChargesSettings.pas_updated_by }}</span>
              </div>
            </div>
          </div>

          <div v-if="roleid == 1" class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ cinemaChargesSettings.pas_updated_at | dateparse }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import DistributorService from "@/services/DistributorService";
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      // Saif
      Cinemas: [],
      CinemasChargeType: [],
      selectedChargeType: "",
      selectedCinema: "",
      cinemaChargesSettings: {
        cinema_id: null,
        pas_id: "",
        cine_name: "",
        ct_name: "",
        pas_charge_value: "",
        pas_is_percentage: "",
        pas_is_deduction: "",
        pas_is_shareable_with_distributor: "",
        pas_is_taxable: "",
        pas_is_active: "",
        created_at: "",
        created_by: "",
        updated_at: "",
        updated_by: "",

        pas_created_at: "",
        pas_created_by: "",
        pas_updated_at: "",
        pas_updated_by: ""
      },
      roleid: ""
    };
  },
  computed: {},
  beforeMount() {
    const { role_id } = this.secureStore.get("USINFO");
    this.roleid = role_id;

    const { id,pas_id, pas_charge_setting_name } = this.$route.query;
    if (pas_charge_setting_name && id) {
      // pas_id
      this.getCinemaChargeDetails(id,pas_charge_setting_name);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    getCinemaChargeDetails: function(cinema_id,pas_charge_setting_name) {
      console.log("pas_id :", pas_charge_setting_name);
      let payload = {
        chargesettingname: pas_charge_setting_name,
        cinema_id : cinema_id
      };
      CinemasService.GetCinemaChargesById(payload)
        .then(response => {
          const { data } = response;
          console.log("data :", data);
          if (data && data.status && data.Records.length > 0) {
            this.CinemasChargeType = data.Records;
            // this.cinemaChargesSettings = data.Records[0];
            let obj = data.Records[0];
            Object.keys(this.cinemaChargesSettings).map(x => {
              this.cinemaChargesSettings[x] =
                obj[x] || this.cinemaChargesSettings[x];
              if (x === "pas_created_by") {
                this.getViewUsersDetails(
                  obj[x],
                  "pas_created_by",
                  "cinemaChargesSettings"
                );
              } else if (x === "pas_updated_by") {
                this.getViewUsersDetails(
                  obj[x],
                  "pas_updated_by",
                  "cinemaChargesSettings"
                );
              }
            });
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error On getCinemaChargeDetails :", error);
        });
    },
    getViewUsersDetails(user_id, fieldvalue, key) {
      this[key][fieldvalue] = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][fieldvalue] = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch(error => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ChargeSettingComponents/viewChargeSetting.vue